import CategoryGroupList from './CategoryGroupList'

export default CategoryGroupList
